import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceDetails } from 'src/app/crmClasses/invoice-details';
import { Product } from 'src/app/crmClasses/product';
import { InvoiceService } from 'src/app/service/invoice.service';
import { ProductService } from 'src/app/service/product.service';
import { SharedDataService } from 'src/app/services/sharedData.service';

@Component({
  selector: 'app-add-new-order-details',
  templateUrl: './add-new-order-details.component.html',
  styleUrls: ['./add-new-order-details.component.scss']
})
export class AddNewOrderDetailsComponent implements OnInit {

  clicked = false;
  invoiceDetailsList: InvoiceDetails[] = []; 
  invoiceDet : InvoiceDetails = new InvoiceDetails;
  
  prod : Product = new Product();
  products: Product[] = [];
  products0: Product[] = [];

  invoiceId!: string;
  officeId!: string;
  addedProductIds : string[] = [];
  productIds : string[] = [];
  qty : any;
  price : any;
  tp : any;
  type : any;
  loggedInUser : any;
  theme : any;
  @Input() fromParent: any;

  @Output() passEntry: EventEmitter<any> = new EventEmitter(); 

  constructor(private  productService : ProductService, 
              private invoiceService : InvoiceService,
              private sharedDataService: SharedDataService,
              public activeModal: NgbActiveModal ) { }
 
  ngOnInit(): void { 

    this.loggedInUser = JSON.parse(this.sharedDataService.getLoggedInUserDtls());
    this.theme = this.sharedDataService.getCardOfficeTheme();
 
    this.invoiceId = this.fromParent.invoiceId;
    this.officeId = this.fromParent.officeId;
    this.type = this.fromParent.type;
 
    this.addedProductIds = this.fromParent.addedProductIds;    

    this.invoiceDet.fkProductId = "";
    
    this.getProducts();
  }

  getFilteredProducts(){
    let count = 0;
    this.addedProductIds.forEach((addedProductId)=>{
      count++;
      this.productIds.forEach((productId,index)=>{
        if(productId==addedProductId)  this.productIds.splice(index,1);
     });
    });  
    if(count === this.addedProductIds.length){
      this.productIds.forEach((val)=>{
        this.products.forEach((prod)=>{
          if(val === prod.productId){
            this.products0.push(prod);
          }
        });
      });
    } 
  }

  onSubmit(){ 

    this.invoiceDet.fkInvoiceId = this.invoiceId;

    this.invoiceService.addInvoiceDetailsByInvId(this.invoiceDet).subscribe(
      data=>{
        this.passEntry.emit(this.invoiceDet);
        this.activeModal.close();
      });
  }

  getProducts(){
    this.productService.getProductListByOfficeId(this.officeId).subscribe(data => {
      this.products= data;

      let count = 0;
      this.products.forEach((val)=>{
        count++;
        this.productIds.push(val.productId);
      });

      if(count === this.products.length){
        this.getFilteredProducts();
      }
    });
  }

  onFileSelected(event: any){
    this.qty = this.invoiceDet.quantity;
    this.price = this.invoiceDet.pricePerItem;

     this.tp = this.qty * this.price;


     this.products.forEach((prod)=>{
      if(prod.productId === this.invoiceDet.fkProductId){
        this.invoiceDet.alternateQuantity = prod.defaultQuantity * this.invoiceDet.quantity;
      }
    });

    this.invoiceDet.totalPriceBeforeDiscount = this.tp;

    if(this.invoiceDet.perAltQuantityDiscountRate === 0){
      this.invoiceDet.totalPrice = this.invoiceDet.totalPriceBeforeDiscount;
    }else{

   let totalDiscountAmount = this.invoiceDet.perAltQuantityDiscountRate * this.invoiceDet.alternateQuantity;

   this.invoiceDet.totalPrice = this.invoiceDet.totalPriceBeforeDiscount - totalDiscountAmount;

    }

  }

  onChange(event : any){
    this.products.forEach((prod)=>{
      if(prod.productId === this.invoiceDet.fkProductId){
        this.invoiceDet.itemName = prod.productName;
        this.invoiceDet.pricePerItem = prod.productPrice;
      }
    });
  }



  getColor(){
    this.sharedDataService.setfooterColor(this.loggedInUser.offices[0].theme);
    return this.loggedInUser.offices[0].theme + '!important';
  } 

  closeModal(){
    this.activeModal.close();
}

}